//Helpers
import { postReq } from '../../../services/http';

export const bulkUpdate = async (deviceID: string, data: object) => {
	try {
		return await postReq(`interface/device/bulk_update`, {
			devices_data: `{"${deviceID}":${JSON.stringify(data)}}`,
		});
	} catch (err) {
		return { isok: false };
	}
};
